"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionInteractionType = void 0;
var CollectionInteractionType;
(function (CollectionInteractionType) {
    CollectionInteractionType["NAVIGATE_TO_COLLECTION_DETAILS"] = "NAVIGATE_TO_COLLECTION_DETAILS";
    CollectionInteractionType["VISIT_LESSON_GUIDE"] = "VISIT_LESSON_GUIDE";
    CollectionInteractionType["COLLECTION_SHARED_TO_GOOGLE_CLASSROOM"] = "COLLECTION_SHARED_TO_GOOGLE_CLASSROOM";
    CollectionInteractionType["COLLECTION_LINK_COPIED"] = "COLLECTION_LINK_COPIED";
})(CollectionInteractionType || (exports.CollectionInteractionType = CollectionInteractionType = {}));
//# sourceMappingURL=CollectionInteractedWithRequest.js.map